/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2020 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import { createSelector } from 'reselect';

import {
  selectAllViewPlugins,
  selectUserViewPlugins,
  selectOrgViewPlugins,
  filterEnabledPlugins,
  groupPlugins
} from '../../common/selectors';

import { manageViewPluginsMode } from '../data/prefabs';

const selectModePlugins = createSelector(
  selectAllViewPlugins,
  manageViewPluginsMode.value,
  selectUserViewPlugins,
  selectOrgViewPlugins,
  (plugins, mode, user, org) => filterEnabledPlugins(plugins, mode === 'org' ? org : user)
);

export const selectModePluginsGrouped = createSelector(
  selectModePlugins,
  groupPlugins
);

export const selectAvailableModePluginsGrouped = createSelector(
  selectModePlugins,
  selectAllViewPlugins,
  (mode, all) => R.pipe(
    R.without(mode),
    groupPlugins
  )(all)
);
